import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useShallow } from "zustand/react/shallow";

import { useAuthStore } from "../stores/authStore";

interface ProtectedRouteProps {
  children: ReactNode;
  permissions?: string[];
  requireAll?: boolean;
}

export default function ProtectedRoute({
  children,
  permissions = [],
  requireAll = false,
}: ProtectedRouteProps) {
  const { user, hasAnyPermission, hasAllPermissions } = useAuthStore(
    useShallow((state) => ({
      user: state.user,
      hasAnyPermission: state.hasAnyPermission,
      hasAllPermissions: state.hasAllPermissions,
    })),
  );

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (permissions.length > 0) {
    const hasAccess = requireAll
      ? hasAllPermissions(permissions)
      : hasAnyPermission(permissions);

    if (!hasAccess) {
      return <Navigate to="/app/reports" replace />;
    }
  }

  return <>{children}</>;
}
